export const reportRoutes = [
  {
    path: "/report/pdf",
    component: () => import("@/views/Report/PDFReport.vue"),
  },
];
